"use client"

import { CheckoutAPISelectionWithRequiredToken } from "@/types/centra/checkout-api/selection/get-selection"
import { TokenAndSelectionMetadata } from "@/types/cookie-types"
import { Result } from "@/types/generic/Result"

type ExtractedCentraSessionCookie = TokenAndSelectionMetadata
export type KeepSelection = {
    checkoutApiSelection?: CheckoutAPISelectionWithRequiredToken
    extractedCentraSessionCookie?: ExtractedCentraSessionCookie
}

export const keepSelection = async (): Promise<Result<KeepSelection>> => {
    return (await fetch("/api/keep-selection", { method: "POST" })).json()
}
